import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeAction } from '../../redux/actions/makeAction';
import { FETCH_STATS_LANDING, OPEN_MODAL } from '../../redux/actions/actionTypes';
import { getActiveWorkersCount, getRealtimePoolHashrate } from '../../redux/selectors/stats';

class IndexPage extends React.PureComponent {
  componentDidMount() {
    this.props.fetchStatsLanding();
  }

  render() {
    return (
      <div id="landing-page">
        <div className="landing-jumboton">
          <div className="container">
            <h1>Dear Users</h1>
            <p> 
We regret to inform you that it has come to our attention that because the website (www.knoxpool.com) is not yet a registered business, 
we unfortunately cannot provide such a service at this time without the proper registered license.
We will inform the community of any updates and developments as soon as possible. We apologize for the inconvenience and thank you for understanding. 
<br/>
Best Regards, <br/>
KnoxPool</p>
          </div>
        </div>
      </div>
    );
  }
}

IndexPage.propTypes = {
  openModal: PropTypes.func.isRequired,
  fetchStatsLanding: PropTypes.func.isRequired,
  realtimePoolHashrate: PropTypes.number,
  activeWorkersCount: PropTypes.number,
};

const mapStateToProps = (state) => ({
  realtimePoolHashrate: getRealtimePoolHashrate(state),
  activeWorkersCount: getActiveWorkersCount(state),
});

const mapDispatchToProps = {
  openModal: makeAction(OPEN_MODAL),
  fetchStatsLanding: makeAction(FETCH_STATS_LANDING),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndexPage);



// WEBPACK FOOTER //
// /src/components/pages/IndexPage.jsx